import { render, staticRenderFns } from "./header-mobile-menu-prefooter.vue?vue&type=template&id=f980ddb0&scoped=true"
import script from "./header-mobile-menu-prefooter.vue?vue&type=script&lang=js"
export * from "./header-mobile-menu-prefooter.vue?vue&type=script&lang=js"
import style0 from "./header-mobile-menu-prefooter.vue?vue&type=style&index=0&id=f980ddb0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f980ddb0",
  null
  
)

export default component.exports